import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexTransferWidgetSettings, DexTransferWidgetSettingsDef} from './dex-transfer-widget-settings';

@Injectable()
export class DexTransferWidgetSettingsService implements WidgetSettingsService {

    private defaultSettingsDef: DexTransferWidgetSettingsDef = {
        title:       null,
        fromAddress: null,
        toAddress:   null,
        assetSymbol: null,
        qty:         null
    };

    public getDefaultSettings(): Observable<DexTransferWidgetSettings> {
        const defaultWidgetSettings: DexTransferWidgetSettings = {
            title:       this.defaultSettingsDef.title,
            fromAddress: this.defaultSettingsDef.fromAddress,
            toAddress:   this.defaultSettingsDef.toAddress,
            assetSymbol: this.defaultSettingsDef.assetSymbol,
            qty:         this.defaultSettingsDef.qty
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DexTransferWidgetSettingsDef): Observable<DexTransferWidgetSettings> {
        return of<DexTransferWidgetSettings>(settingsDef && {
            title:       null,
            fromAddress: settingsDef.fromAddress,
            toAddress:   settingsDef.toAddress,
            assetSymbol: settingsDef.assetSymbol,
            qty:         settingsDef.qty
        } satisfies DexTransferWidgetSettings);
    }

    public toDefinition(settings: DexTransferWidgetSettings): DexTransferWidgetSettingsDef {
        return settings && {
            title:       null,
            fromAddress: settings.fromAddress,
            toAddress:   settings.toAddress,
            assetSymbol: settings.assetSymbol,
            qty:         settings.qty
        };
    }

}
